import {Litepicker} from "litepicker/dist/nocss/litepicker.umd";
import "litepicker/dist/nocss/plugins/mobilefriendly";
import "litepicker/dist/plugins/ranges";
import 'litepicker/dist/plugins/multiselect';


export default class Datepicker {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.datepicker'), el => {
			new Datepicker(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.language = document.querySelector('html').getAttribute('lang') || 'en-US';
		this.type = element.dataset.type;
		let today = new Date();
		let day = 24 * 60 * 60 * 1000;
		let week = 7 * 24 * 60 * 60 * 1000;
		let tomorrow = new Date(today.getTime() + day);
		let thisWeekEnd = new Date(today.getTime() + week - today.getDay() * day);
		let nextWeekStart = new Date(thisWeekEnd.getTime() + day);
		let nextWeekEnd = new Date(thisWeekEnd.getTime() + week);
		let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		let nextMonthStart = new Date(today.getFullYear(), today.getMonth() + 1, 1);
		let nextMonthEnd = new Date(today.getFullYear(), today.getMonth() + 2, 0);

		this.datepicker = new Litepicker({
			element: element,
			singleMode: this.type === 'single',
			inlineMode: true,
			lang: this.language,
			autoApply: true,
			tooltipText: {
				one: element.dataset.dayLabel,
				other: element.dataset.daysLabel,
			},
			buttonText: {
				previousMonth: '<span class="litepicker__button litepicker__button--prev"></span>',
				nextMonth: '<span class="litepicker__button litepicker__button--next"></span>'
			},
			plugins: ['mobilefriendly', this.type !== 'single' ? this.type : null],
			ranges: {
				customRanges: {
					[this.multiLanguage('Today')]: [today, today],
					[this.multiLanguage('Tomorrow')]: [tomorrow, tomorrow],
					[this.multiLanguage('This Week')]: [today, thisWeekEnd],
					[this.multiLanguage('Next Week')]: [nextWeekStart, nextWeekEnd],
					[this.multiLanguage('This Month')]: [today, thisMonthEnd],
					/*[this.multiLanguage('Next Month')]: [nextMonthStart, nextMonthEnd],*/
				},
				position: 'bottom'
			},
			tooltipNumber: (totalDays) => {
				return totalDays - 1;
			}
		});

		this.datepicker.on('selected', (date1, date2) => {
			// handle selection of range
			this.element.dispatchEvent(new CustomEvent('preselect', {detail: [date1, date2]}));
		});

		this.datepicker.on('preselect', (date1, date2) => {
			if (date2) return;
			// only is first date is picked
			this.element.dispatchEvent(new CustomEvent('preselect', {detail: [date1, date2]}));
		});

		// link handler
		window.addEventListener('click', (e) => {
			let target = e.target;

			if (target.dataset.type === 'form-link') {
				e.preventDefault();
				e.stopPropagation();

				let startDate = new Date(parseInt(target.dataset.dateStart) * 1000)
				let endDate = new Date(parseInt(target.dataset.dateEnd) * 1000)
				let dates = target.dataset.dates ? target.dataset.dates.split(',').map(el => parseInt(el) * 1000) : null;

				if (startDate && endDate) {
					this.datepicker.setDateRange(startDate, endDate);
					this.datepicker.gotoDate(startDate);
				}

				if (dates.length) {
					this.datepicker.setHighlightedDays(dates);
					this.datepicker.gotoDate(dates[dates.length - 1]);
					dates.forEach(el => {
					});
				}
			}
		});
	}

	multiLanguage(text) {
		let shortLang = this.language.split('-')[0];
		let phrases = [
			{
				en: 'Today',
				it: 'Oggi',
				de: 'Heute'
			},
			{
				en: 'Tomorrow',
				it: 'Domani',
				de: 'Morgen'
			},
			{
				en: 'This Week',
				it: 'Questa settimana',
				de: 'Diese Woche'
			},
			{
				en: 'Next Week',
				it: 'La prossima settimana',
				de: 'Nächste Woche'
			},
			{
				en: 'This Month',
				it: 'Questo mese',
				de: 'Diesen Monat'
			},
			{
				en: 'Next Month',
				it: 'La prossima settimana',
				de: 'Nächsten Monat'
			},
		]

		// returns localised phrase, based on english
		return phrases.find(el => el.en.toLowerCase() === text.toLowerCase())[shortLang] || 'None';
	}
}
